/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class NotebookExecutionOutput {
  /**
  * Output type following Jupyter protocol
  */
  'type': NotebookExecutionOutputTypeEnum;
  /**
  * Stream name (stdout/stderr)
  */
  'name'?: string | null;
  /**
  * Text content for stream outputs
  */
  'text'?: string | null;
  /**
  * MIME-keyed data for rich outputs (text/plain, text/html, image/png, etc.)
  */
  'data'?: { [key: string]: any; } | null;
  /**
  * Error name
  */
  'ename'?: string | null;
  /**
  * Error value
  */
  'evalue'?: string | null;
  /**
  * Error traceback lines
  */
  'traceback'?: Array<string> | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "type",
      "baseName": "type",
      "type": "NotebookExecutionOutputTypeEnum",
      "format": ""
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "text",
      "baseName": "text",
      "type": "string",
      "format": ""
    },
    {
      "name": "data",
      "baseName": "data",
      "type": "{ [key: string]: any; }",
      "format": ""
    },
    {
      "name": "ename",
      "baseName": "ename",
      "type": "string",
      "format": ""
    },
    {
      "name": "evalue",
      "baseName": "evalue",
      "type": "string",
      "format": ""
    },
    {
      "name": "traceback",
      "baseName": "traceback",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return NotebookExecutionOutput.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum NotebookExecutionOutputTypeEnum {
  NOTEBOOK_OUTPUT_TYPE_STREAM = 'stream',
  NOTEBOOK_OUTPUT_TYPE_EXECUTE_RESULT = 'execute_result',
  NOTEBOOK_OUTPUT_TYPE_DISPLAY_DATA = 'display_data',
  NOTEBOOK_OUTPUT_TYPE_ERROR = 'error'
}

